import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSortable } from "@dnd-kit/sortable";
import { ActionIcon, Flex, Text } from "@mantine/core";
import { BoltOutlined, Delete, DragIndicatorOutlined, Edit, LockOutlined } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
export const SortablePriorityStatus = ({ priorityStatus, onClickEdit, onClickDelete }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id: priorityStatus.priorityStatusId
    });
    return (_jsxs(Flex, { ref: priorityStatus.isMutable ? setNodeRef : undefined, className: "hover-opacity-parent", justify: "space-between", style: {
            paddingRight: "1rem",
            marginTop: "0.2rem",
            borderRadius: "0.2rem",
            minHeight: "2rem",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            backgroundColor: priorityStatus.colorHex,
            cursor: priorityStatus.isMutable ? "grab" : "default",
            transform: transform
                ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
                : undefined,
            transition
        }, children: [_jsx("div", { style: {
                    width: "100%"
                }, ...attributes, ...listeners, children: _jsx(Flex, { style: { width: "100%" }, justify: "space-between", children: _jsxs(Flex, { align: "center", children: [_jsx(SvgIcon, { component: priorityStatus.isMutable
                                    ? DragIndicatorOutlined
                                    : LockOutlined, style: {
                                    fontSize: "1rem",
                                    color: "grey",
                                    marginLeft: "0.5rem"
                                } }), _jsx(Text, { variant: "body", style: {
                                    marginLeft: "0.5rem",
                                    fontSize: "smaller"
                                }, children: priorityStatus.name })] }) }) }), _jsxs(Flex, { children: [_jsx(ActionIcon, { variant: "transparent", onClick: () => onClickEdit(priorityStatus), children: _jsx(SvgIcon, { className: "hover-opacity", component: Edit, style: { fontSize: "1rem", color: "grey" } }) }), priorityStatus.isMutable ? (_jsx(ActionIcon, { variant: "transparent", onClick: () => onClickDelete(priorityStatus), children: _jsx(SvgIcon, { className: "hover-opacity", component: Delete, style: { fontSize: "1rem", color: "grey" } }) })) : (_jsx("div", { style: { width: "1.8rem" } }))] }), _jsx(SvgIcon, { visibility: priorityStatus.simpleEmailTemplateId ? "visible" : "hidden", component: BoltOutlined, style: {
                    fontSize: "1rem",
                    color: "grey",
                    marginRight: "0.2rem",
                    marginTop: "0.35rem"
                } })] }));
};
